import React from "react";
import "./Home/App.css";
import { Route, Routes } from "react-router-dom";
import HomePage from "./Home/HomePage";
// import ContactPage from "./Home/ContactPage";
import "./styles.css";
// import BusinessDev from "./Squeeze_Page/all_webs/business/Business_dev";
// import Digital_Mark from "./Squeeze_Page/all_webs/business/Digit_market";
// import Gym from "./Squeeze_Page/all_webs/business/GYM";
// import Burger from "./Squeeze_Page/all_webs/food/Burger_resto";
// import Pizza from "./Squeeze_Page/all_webs/food/Pizza_resto";
// import DanceStudio from "./Squeeze_Page/all_webs/other/Dance_studio";
// import Clinic from "./Squeeze_Page/all_webs/clinicx/Clinic";
// import Main from "./Squeeze_Page/main";
// import BuildContract from "./Squeeze_Page/all_webs/business/BuildContractor";
// import Health_beauty_store from "./Squeeze_Page/all_webs/business/Health_beauty_store";
// import Jewels from "./Squeeze_Page/all_webs/business/Jewel_store";
// import Plans from "./Home/PricingPlans/Plans";
// import axios from "axios";
// import NewYearMain from "./2022YearSqueeze/NewYearMain";
import "./App.css";
import Homepage from "./VersionTwoPages/HomePage";


function App() {
  
    // const msg = firebase.messaging();
    // msg
    //   .requestPermission()
    //   .then(() => {
    //     return msg.getToken();
    //   })
    //   .then((data) => {
    //     console.warn("token", data);
    //   });

    // React.useEffect(() => {
    //   axios.get('https://api.ipify.org')
    //   .then((resp) => {
    //     const ip_address = resp.data;
    //     const co_name = 'WEB DEV'
    //     axios.post('https://apiservicesforwebapps.herokuapp.com/api/get',{
    //       co_name,
    //       ip_address
    //     })
    //     .then((resp) => {
    //       console.log(resp)
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    //   })
      
    // })
 

  return (
    <>
        <Routes>
          <Route exact path="/" element={<Homepage/>} />
          {/* <Route exact path="/contactus" component={ContactPage} /> */}
          {/* <Route exact path="/main" component={Main} /> */}
          {/* <Route exact path="/plans" component={Plans} /> */}
          {/* <Route exact path="/newyear" component={NewYearMain}/> */}

          {/* PAGES */}

          {/* <Route exact path="/contractor" component={BuildContract} />
          <Route exact path="/business-dev" component={BusinessDev} />
          <Route exact path="/digital-market" component={Digital_Mark} />
          <Route exact path="/gym" component={Gym} />

          <Route exact path="/food/burger" component={Burger} />
          <Route exact path="/food/pizza" component={Pizza} />

          <Route exact path="/dance" component={DanceStudio} />

          <Route exact path="/beauty-store" component={Health_beauty_store} />
          <Route exact path="/jewels-store" component={Jewels} />

          <Route exact path="/clinic" component={Clinic} /> */}
        </Routes>
    </>
  );
}

export default App;
